import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PorteurService } from "../porteur.service";
import { ArticlePorteur } from "./article";

@Injectable({
  providedIn: 'root'
})
export class ArticleResolver {
  constructor(
    private porteurService: PorteurService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ArticlePorteur> {
    let art =  this.porteurService.getArticle(route.parent.parent.params.numPorteur, route.params.code_article, route.params.taille, route.params.code_service);
    return art;
  }

}
